import { render, staticRenderFns } from "./Outcome.vue?vue&type=template&id=2f942996&"
import script from "./Outcome.vue?vue&type=script&lang=ts&"
export * from "./Outcome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports